import { cn } from '@/lib/utils'

type CardProps = React.PropsWithChildren<React.HtmlHTMLAttributes<HTMLDivElement>>

function Card({ children, ...props }: CardProps) {
	return (
		<div {...props} className={cn('rounded-4xl bg-neutral', props.className)}>
			{children}
		</div>
	)
}

export { Card, type CardProps }
